"use client";

import { ChartOptions } from "chart.js";
import { parse } from "date-fns";
import { Line } from "react-chartjs-2";
import { chartColors, chartJsGridColor, chartJsTextColor } from "@portal/helpers/chartJs";
import { isDarkMode } from "@portal/helpers/darkMode";
import obx_data from "./behaviourData/obx_data.json";

const parseDate = (dateString: string): number => parse(dateString, "dd.MM.yyyy", new Date()).getTime();

/**
 * Chart.js version of the behaviour (Oslo Børs) line chart.
 * @returns a chart.
 */
export const BehaviourChart = () => {
  const points = [...obx_data].reverse().map(dataEl => ({ x: parseDate(dataEl.date), y: Number(dataEl.price) }));

  const options: ChartOptions<"line"> = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    elements: { point: { radius: 0, hoverRadius: 4 } },
    scales: {
      x: {
        type: "time",
        time: { tooltipFormat: "dd.MM.yyyy", displayFormats: { day: "dd.MM.yyyy", month: "MM.yyyy" } },
        ticks: { color: chartJsTextColor(), maxRotation: 0, autoSkip: true, maxTicksLimit: 6 },
        grid: { display: false },
      },
      y: { ticks: { color: chartJsTextColor() }, grid: { color: chartJsGridColor() } },
    },
    plugins: { legend: { display: false } },
  };

  return (
    <div style={{ height: 320 }}>
      <Line
        data={{
          datasets: [
            {
              label: "Oslo Børs",
              data: points,
              borderColor: isDarkMode() ? chartColors.blueHighcharts : chartColors.darkBlue,
              borderWidth: 1,
              tension: 0,
            },
          ],
        }}
        options={options}
      />
    </div>
  );
};
